export const NOT_AVAILABLE_TEXT = 'Not available';
export const DATA_PENDING_TEXT = 'Data pending';
